"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numFormat = exports.numAlter = exports.isUrl = exports.isJSON = exports.anyInArray = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.replace.js");
/** 判断数据是否是 url
 * @param { String } str 输入的字符串
 * @return { Boolean } 返回判断结果
 */
var isUrl = exports.isUrl = function isUrl(str) {
  if (typeof str === 'string') return /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/.test(str);
  return false;
};

/** 判断数据是否是 json 字符串
 * @param { String } str 输入的字符串
 * @return { Boolean } 返回判断结果
 */
var isJSON = exports.isJSON = function isJSON(str) {
  if (str && typeof str === 'string') {
    return /^[\],:{}\s]*$/.test(str.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
  }
  return false;
};

/** 非数组类型数据封装到数组中
 * @description: 数组还是返回数组，非数组类型数据封装到数组中
 * @param { * } data 待处理数据
 * @return { Array } 返回数据
 */
var anyInArray = exports.anyInArray = function anyInArray(data) {
  if (Array.isArray(data)) return data;
  return [data];
};

/** 阿拉伯数字改变
 * @description: 将阿拉伯数字转换成指定类型
 * @param { Number } num 待处理数字
 * @param { String } type 要转换的类型 [chinese or chinese-small - 中文小写, chinese-big]
 * @return { String } 返回数据
 */
var numAlter = exports.numAlter = function numAlter(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'chinese';
  num *= 1;
  if (typeof num !== 'number') return null;
  return num.toString().split('').map(function (s) {
    var n = s * 1;
    if (type === 'chinese' || type === 'chinese-small') return ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][n];
    if (type === 'chinese-big') return ['零', '壹', '貮', '叁', '肆', '伍', '陆', '柒', '捌', '玖', '拾'][n];
    return n;
  }).join('');
};

/** 数字千分位符号转换
 * @description: 将阿拉伯数字进行千分位符号转换，如果是数字就转换成 带千分位符号的字符串，如果是带千分位符号的字符串，就转换成数字
 * @param { Number | String } num 待转换的数字 number 或者 能直接转换成数字的字符串 或者 一个经过千分位符号处理过的数字字符串
 * @param { Boolean } type 是否是用逗号分割，true 用逗号分割，false 用空格分割， 默认false
 * @return { Number | String } 处理后的数字
 */
var numFormat = exports.numFormat = function numFormat(num) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (/^[0-9]+\.?[0-9]*$/.test(num)) return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, type ? ',' : ' ');else if (/^[0-9,]+\.?[0-9,]*$/.test(num)) {} else return null;
  return '';
};